const appStage = process.env.REACT_APP_STAGE as string

export enum Endpoints {
  Base = '/api/student',
  RefreshToken = '/auth/refresh-token',
  Initial = '/initial',
  Logout = '/logout',
  Profile = '/profile',
  ProfileChangeLogin = '/profile/change-login',
  ProfileChangePassword = '/profile/change-password',
  UploadImageProfile = '/upload/student-profile',
  SignIn = '/auth/sign-in',
  Payments = '/payments',
  Groups = '/groups',
  GroupInfo = '/groups/{id}/lessons',
  Rating = '/awards/statistics',
  Files = '/files',
  LevelsByCategory = '/levels/all',
  homeworkChats = '/homework-chats',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  GroupLesson = '/groups/{id}/lessons',
  GroupLessonRating = '/groups/lesson/rating',
  GroupHomeworkChats = '/homework-chat/{groupId}/homework-chats',
  HomeworkFileUpload = '/upload/homework-attachments',
  HomeworkSend = '/homework-chat/create',
  Categories = '/categories',
  Awards = '/awards',
  AwardsStatistic = '/awards/statistic',
  AwardsByDasboard = '/awards/dashboard',
  LessonAwards = '/lessons/last-lesson',
  Courses = '/courses',
  StatisticsMethods = '/awards/methods',
  LessonsByGroup = '/lessons/by-group',
  LessonVideoNameByGroup = 'lessons/videos-by-lesson',
  SenderLog = '/sender/log',
  Tus = '/tus',
  GamificationOffer = '/oferta/get-oferta',
  GamificationOfferApprove = '/oferta/approve-oferta',
  Offices = '/offices',
  HomeworkChatUpdate = '/homework-chat/update',
  Notifications = '/notifications',
  Count = '/count',
  GetAll = '/get-all',
  Read = '/read',
  Exams = '/exams',
  Chats = '/chats',
  Submit = '/submit',
  Students = '/students',
  LastVideo = '/videos/last-video',
  LessonDays = '/lessons/days',
  LessonsByDate = '/lessons/by-date',
  Store = '/store',
  Items = '/items',
  Transactions = '/transactions',
  Certificates = '/certificates',
  Detail = '/detail',
  AuthLogOut = '/auth/logout',
  Settings = '/settings',
  All = '/all',
  Contracts = '/contracts/public',
  ContractSentOtp = '/contracts/sendOtp',
  ContractAccept = '/contracts/accept',
  MyContracts = '/contracts/mine',
  FilterObjects = '/awards/filter-objects',
  HomeworkChatSubmissions = '/homework-chat/submissions',
}

const stages: Record<string, { apiUrl: string; cdnHost: string }> = {
  dev: {
    apiUrl: 'https://dev.api.robbit.uz',
    cdnHost: 'https://pub-34cf611d16c545c6ba146f59e82d8ee1.r2.dev',
  },
  test: {
    apiUrl: 'https://test.robbit.api.najotedu.uz',
    cdnHost: 'https://pub-bdaa3a47da004acab9e82c400fe728a3.r2.dev',
  },
  prod: {
    apiUrl: 'https://api.robbit.uz',
    cdnHost: 'https://pub-c19abddd489f489ba8888e8188e32190.r2.dev',
  },
}

export const stage = stages[appStage]
